import React, { createContext, useContext, useState, ReactNode } from 'react';

interface ActivePatrolUIContextType {
	showDrawer: boolean;
	showDrawerSkeleton: boolean;
	showLoadingBackdrop: boolean;
	showUnsavedWarningModal: boolean;
	showIncompleteWarningModal: boolean;
	showActivePatrolWarningModal: boolean;
	setShowDrawer: (status: boolean) => void;
	setShowDrawerSkeleton: (status: boolean) => void;
	setShowLoadingBackdrop: (status: boolean) => void;
	setShowUnsavedWarningModal: (status: boolean) => void;
	setShowIncompleteWarningModal: (status: boolean) => void;
	setShowActivePatrolWarningModal: (status: boolean) => void;
}

const ActivePatrolUIContext = createContext<
	ActivePatrolUIContextType | undefined
>(undefined);

export const ActivePatrolUIProvider: React.FC<{ children: ReactNode }> = ({
	children,
}) => {
	const [showDrawer, setShowDrawer] = useState<boolean>(false);
	const [showDrawerSkeleton, setShowDrawerSkeleton] =
		useState<boolean>(false);
	const [showLoadingBackdrop, setShowLoadingBackdrop] =
		useState<boolean>(false);
	const [showUnsavedWarningModal, setShowUnsavedWarningModal] =
		useState<boolean>(false);
	const [showIncompleteWarningModal, setShowIncompleteWarningModal] =
		useState<boolean>(false);
	const [showActivePatrolWarningModal, setShowActivePatrolWarningModal] =
		useState<boolean>(false);

	return (
		<ActivePatrolUIContext.Provider
			value={{
				showDrawer,
				showDrawerSkeleton,
				showLoadingBackdrop,
				showUnsavedWarningModal,
				showIncompleteWarningModal,
				showActivePatrolWarningModal,
				setShowDrawer,
				setShowDrawerSkeleton,
				setShowLoadingBackdrop,
				setShowUnsavedWarningModal,
				setShowIncompleteWarningModal,
				setShowActivePatrolWarningModal,
			}}
		>
			{children}
		</ActivePatrolUIContext.Provider>
	);
};

export const useActivePatrolUI = () => {
	const context = useContext(ActivePatrolUIContext);
	if (!context)
		throw new Error('useUIContext must be used within a UIProvider');
	return context;
};
